/**
 * OC FAB Button Component
 * Floating Action Button for opening the chat panel
 */

import colors from '@hl/ui-components/styles/colors.scss';
import React from 'react';

import { AiIcon } from '../../../AiIcon/AiIcon';
import { useOcFabWidgetOptions } from '../../contexts/OcFabWidgetOptionsContext';
import { FabAvatar, StyledFabButton } from './OcFabButton.styled';

export interface OcFabButtonProps {
  onClick: () => void;
}

/**
 * OcFabButton Component
 * Circular floating button that opens the chat panel
 */
const OcFabButton: React.FC<OcFabButtonProps> = ({
  onClick,
}) => {
  const {
    assistantName,
    avatarUrl,
    title,
    fabPosition
  } = useOcFabWidgetOptions();

  return (
    <StyledFabButton
      type="button"
      onClick={onClick}
      aria-label={title}
      title={title}
      $position={fabPosition}
      className="hl-oc-chat-content"
    >
      {avatarUrl ? (
        <FabAvatar src={avatarUrl} alt={assistantName} />
      ) : (
        <AiIcon style={{ border: `solid 2px ${colors.white}` }} />
      )}
    </StyledFabButton>
  );
};

export default OcFabButton;

